import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';

let baseStyles = {
    container: {
        overflow: 'visible',
        paddingBottom: Theme.primaryPaddingBottom,
        paddingHorizontal: Theme.primaryMargin
    },
    carousel: {
        marginTop: 20,
        marginEnd: -Theme.primaryMargin,
        marginRight: -Theme.primaryMargin
    },
    promoCarousel: {
        marginBottom: 20
    }
};

if (Device.isTabletOrWeb) {
    baseStyles = {
        ...baseStyles,
        tvGuideButton: {
            alignSelf: 'flex-end'
        }
    };
}

export default StyleSheet.create(baseStyles);
